module.exports = __webpack_public_path__ + "img/Max.051bd6f6.jpg";